__turbopack_context__.v({
  "loadingGradient": "_2qMl6q_loadingGradient",
  "rotate-loading-gradient": "_2qMl6q_rotate-loading-gradient",
});
